module.exports = __webpack_public_path__ + "img/icono-21-1.eec5f583.png";